<template>
  <div>
    <img src="../../assets/Loading/loadLogo.png" class="loading-logo"/>
  </div>
</template>

<script>
  export default {
    name: 'Logo',
  };
</script>

<style scoped>
  .loading-logo {
    animation: appear 2s ease;
  }

  @keyframes appear {
    0% {
      transform: translateY(+20px);
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Loading/Logo.vue